var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar"},[_c('van-tabbar',{attrs:{"safe-area-inset-bottom":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.list),function(tab,index){return _c('van-tabbar-item',{key:index,attrs:{"icon":tab.icon,"to":tab.path}},[_vm._v(_vm._s(tab.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }